import van from 'vanjs-core';
import {
    Page1AreaPlant, Page1NominalPower, Page1NominalPowerAreaPlantSm
} from "../../components/page1/page-specific-tags";
import {BigTag} from "../../components/big-tag";
import {
    energyAmount,
    energyTotalAmount,
    energySaved,
    graphValue,
    percentageText,
    powerProductionValue,
    nominalPower,
    areaPlant,
    energyUnit,
    treesSaved
} from "../../state-variables";

const {div, img, span} = van.tags;
const {svg, circle, text} = van.tags("http://www.w3.org/2000/svg");


// Hlavní obsahové okno na 1. obrazovce
export const MainContent = () => {


    return div({class: "w-100 main-content p-0 py-mn m-0 justify-content-center d-flex flex-column main-content-radius"},
        div({class: "w-100 row container-fluid p-0 m-0", style:"height: fit-content; z-index: 1;"},
            div({class: "col-lg-4 col-md-12 d-flex flex-column align-items-center bg-light-see-through justify-content-between section-padding section-padding-y0"},
                div({class: "section-aligner"},
                    div({class: "item d-flex flex-column align-items-center w-100"},
                        BigTag("DENNÍ PRODUKCE", "DAILY ENERGY", energyAmount, energyUnit),
                    ),
                    div({class: "item d-flex flex-column align-items-center w-100"},
                        BigTag("CELKOVÁ PRODUKCE", "TOTAL ENERGY", energyTotalAmount, "MWh"),
                    ),
                    div({class: "item d-flex flex-column align-items-center w-100"},
                        BigTag("ZADRŽENO CO2", "TOTAL CO2 SAVED", energySaved, "ton", true),
                        div({class: "d-flex flex-row mt-2 justify-content-end ms-auto"},
                            div({class: "d-flex flex-column align-items-end"},
                                span({class: "big-text text-dark-blue"}, () => treesSaved.val),
                                span({class: "text-dark-blue md-tag-text mb-1"}, "SAVED TREES"),
                                span({class: "text-green md-tag-text"}, "STROMŮ UŠETŘENO"),
                            ),
                            div({class: "tree-wrap"},
                                img({src:"/icons/g672.svg",alt:"little_tree", class: "tree-icon"}),
                            ),
                        ),
                    ),
                ),
            ),
            div({class: "col-lg-4 col-md-12 p-0 d-flex flex-column align-items-center bg-light-see-through justify-content-center section-padding-y0"},
                div({class: "section-aligner"},
                    div({class: "w-100 h-100 justify-content-between d-flex flex-column"},
                        div({class: "graph-container circular-graph-padding"},
                            svg({width: "200", height: "200", viewBox: "-25 -25 250 250", version: "1.1", xmlns: "http://www.w3.org/2000/svg", style: "transform:rotate(110deg)"},
                                circle({"r": "90", cx: "100", cy: "100", fill: "transparent", stroke: "#0066AE", "stroke-width": "11px", "stroke-linecap": "round", "stroke-dashoffset": "65px", "stroke-dasharray": "565.48px"}),
                                circle({"r": "90", cx: "100", cy: "100", stroke: "#45C0EA", "stroke-width": "12px", "stroke-linecap": "round", "stroke-dashoffset": () => graphValue.val.toString() + "px", fill: "transparent", "stroke-dasharray": "565.48px"}),
                                text({"x": "-50%", "y": "30%", fill: "#45C0EA", "text-anchor": "middle", "font-size": "2rem", "font-weight": "500", style: "transform: rotate(250deg)"},
                                    () => percentageText.val.toString() + "%",
                                ),
                            ),
                        ),
                        div({class: "d-flex flex-column align-items-center section-padding", style: "padding-top: 0 !important; padding-bottom: 0 !important;"},
                            BigTag("AKTUÁLNÍ PRODUKCE", "POWER PRODUCTION", powerProductionValue, "kW", false, true, true),
                        ),
                    ),
                ),
            ),
            div({class: "col-lg-4 col-md-12 d-flex flex-column align-items-center bg-light-see-through justify-content-between section-padding section-padding-y0"},
                div({class: "section-aligner"},
                    Page1NominalPowerAreaPlantSm(nominalPower, areaPlant),
                    div({class: "mobile-spacer"}),
                    div({class: "image-wrapper w-100 big-tag-border"},
                        img({src: "/img/LPParkingCCompressed.JPG", alt: "solary", style: "width: 100% !important;", loading: "lazy", decoding: "async"})
                    ),
                    div({class: "d-flex flex-column mx-auto",style: "width: fit-content !important;"},
                        Page1AreaPlant(areaPlant),
                        Page1NominalPower(nominalPower),
                    ),
                ),
            ),
        )
    );
};